import React from "react"

const CaseStudiesHero = () => {
  return (
    <section className="hero has-background-dark hero-case-studies">
      <div className="hero-title-container">
        <div className="container case-studies-hero-content">
          <h1 className="title is-1 is-size-3-mobile has-text-white mb-4 has-line-height-1 has-text-centered">
            Client Success Stories
          </h1>
          <p className="subtitle is-5 has-text-white-bis has-text-weight-light mb-5 mt-5 has-text-centered">
            See how leading brands use our AI solutions to solve real problems,
            improve efficiency, and achieve measurable success in competitive
            markets.
          </p>
        </div>
      </div>
    </section>
  )
}

export default CaseStudiesHero
